export const DataRouteParamPersonId = 'personId';
